import React from 'react';
import {connect} from 'react-redux';
import CustomPageLayout from "./CustomPageLayout";
import AdminMenu from "../administrace/lists/components/AdminMenu";
import KombinaceList from '../administrace/lists/components/KombinaceList';

/**
 * Stránka administrace, zobrazující menu po levé straně a obsah konkrétní stránky vpravo.
 */
class KombinacePage extends React.Component {

    render() {
        return (
            <CustomPageLayout
                header
                 headerButton={false}
                searchField={false}
                title="Kombinace"
                menu={<AdminMenu />}>
                <KombinaceList/>
            </CustomPageLayout>
        );
    }
}

function mapStateToProps(state) {
    return state;
}

export default connect(mapStateToProps)(KombinacePage);
